export default __webpack_public_path__ + "static/mark-robinette-e8e516a99539303e843bf59425e5008f.jpg";